/** 

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

import { forwardRef } from "react";
import type { ComponentProps, ElementType, ReactNode } from "react";
import type { ButtonProps } from "@mui/material/Button";

// Custom styles for VuiButton
import VuiButtonRoot from "components/VuiButton/VuiButtonRoot";

type OwnerState = ComponentProps<typeof VuiButtonRoot>["ownerState"];

type VuiButtonProps = Omit<ButtonProps, keyof OwnerState | "children"> &
  Partial<OwnerState> & {
    component?: ElementType;
    // With a link `component`: passed through to the rendered link.
    target?: string;
    rel?: string;
    children: ReactNode;
  };

const VuiButton = forwardRef<HTMLButtonElement, VuiButtonProps>(
  (
    {
      color = "white",
      variant = "contained",
      size = "medium",
      circular = false,
      iconOnly = false,
      children,
      ...rest
    },
    ref
  ) => (
    <VuiButtonRoot
      {...rest}
      ref={ref}
      color="white"
      variant={variant === "gradient" ? "contained" : variant}
      size={size}
      ownerState={{ color, variant, size, circular, iconOnly }}
    >
      {children}
    </VuiButtonRoot>
  )
);

export default VuiButton;
